<template>
	<div>
		<v-list>
			<template v-for="(item, index) in locations">
				<v-list-item
					:key="item.created"
					@click="
						() =>
							addOrEditItem({
								id: item.id,
								operation: 'edit',
							})
					"
				>
					<v-list-item-avatar>
						<v-badge
							v-if="!item.addButton"
							bottom
							:color="item.active ? 'green' : 'grey'"
							dot
							offset-x="10"
							offset-y="10"
						>
							<v-icon>folder_open</v-icon>
						</v-badge>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title v-html="item.name"></v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<v-menu v-if="!item.addButton" bottom left>
							<template v-slot:activator="{ on }">
								<v-btn icon small v-on="on">
									<v-icon>more_vert</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item
									@click="
										() =>
											addOrEditItem({
												id: item.id,
												operation: 'edit',
											})
									"
								>
									<v-list-item-title>{{
										$t('text.edit-location')
									}}</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</v-list-item-action>
				</v-list-item>

				<v-divider
					:key="index"
					v-if="index < locations.length - 1"
					inset
				></v-divider>
			</template>
		</v-list>
		<div style="padding: 1rem">
			<v-btn
				small
				@click="
					() =>
						addOrEditItem({
							operation: 'add',
						})
				"
			>
				<v-icon left>add</v-icon> {{ $t('button.add-location') }}
			</v-btn>
		</div>
		<LocationAttrs
			v-if="isLocationAttrsVisible"
			:method="locationActionMethod"
			:location="locationToEdit"
			:onClose="handleLocationAttrsClose"
		></LocationAttrs>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import LocationAttrs from './locationAttrs/LocationAttrs';

export default {
	name: 'Locations',
	components: {
		LocationAttrs,
	},
	computed: {
		...mapState({
			locations: state => state.locations.items,
		}),
	},
	data() {
		return {
			isLocationAttrsVisible: false,
			locationActionMethod: 'edit',
			locationToEdit: {},
		};
	},
	methods: {
		addOrEditItem({ id, operation }) {
			if (operation === 'edit') {
				this.locationActionMethod = 'edit';
				this.locationToEdit = this.locations.find(item => item.id === id);
			} else if (operation === 'add') {
				this.locationActionMethod = 'add';
				this.locationToEdit = {
					active: true,
					name: '',
				};
			}
			this.isLocationAttrsVisible = true;
		},
		handleLocationAttrsClose() {
			this.isLocationAttrsVisible = false;
		},
	},
	created() {
		this.$store.dispatch('locations/get', { updateStore: true });
	},
};
</script>
